<template>
  <div class="index">
    <h3 class="buy-title">
      {{ title }}
      <!-- <span class="title-contact">
        服务咨询，请致电
        <span style="color:#3BC492">18971608045</span>
      </span> -->
    </h3>
    <div ref="container" class="buy-content" v-if="serviceList.length">
      <div
        v-for="(i, j) in serviceList"
        :key="j"
        class="border-class"
        :style="{ 'border-top-color': color[j] }"
      >
        <h4 :style="{ color: color[j] }">{{ i.serviceType }}</h4>
        <p>
          总条数：
          <span>{{ i.totalNum }}</span>
        </p>
        <p>
          赠送条数：
          <span>{{ i.giveNum }}</span>
        </p>
        <p>
          已使用条数：
          <span>{{ i.useNum }}</span>
        </p>
        <p style="padding-top: 20px">
          剩余条数：
          <span>{{ i.totalNum + i.giveNum - i.useNum }}</span>
        </p>
        <p>
          使用时间：
          <span>{{
            i.beginTime.slice(0, 10) + " 至 " + i.endTime.slice(0, 10)
          }}</span>
        </p>
        <div>
          <p v-if="i.serviceType == '免费版'">
            <el-button
              size="small"
              style="float: right; margin-top: 10px"
              round
              :disabled="!userInfo.isFree"
              >{{ userInfo.isFree ? "申请" : "已申请" }}</el-button
            >
          </p>
          <p v-else>
            <el-button
              size="small"
              style="float: right; margin-top: 10px"
              round
              :loading="i.isLoading"
              :disabled="new Date(i.endTime) < new Date() ? true : false"
              @click="hanldeRenewal(i)"
              >继续购买</el-button
            >
          </p>
        </div>
      </div>
    </div>
    <div v-else style="text-align: center; line-height: 100px">
      暂无购买数据
    </div>
    <!-- <p class="btn-container"><span @click="handleCospla">{{isCospla?'隐藏':'展开'}}</span></p> -->
  </div>
</template>

<script>
import Cookie from "js-cookie";
import { customerServiceInfo } from "@/api/setUp.js";
export default {
  name: "index",
  props: {
    title: String,
  },
  components: {},
  data() {
    return {
      isCospla: true,
      userInfo: {},
      serviceList: [],
      isLoading: false,
      color: {
        0: "#3BC492",
        1: "#3A84FF",
        2: "#758BB1",
        3: "#FF6161",
      },
    };
  },
  methods: {
    handleCospla() {
      this.isCospla = !this.isCospla;
      this.$refs.container.style.height == "151px"
        ? (this.$refs.container.style.height = "302px")
        : (this.$refs.container.style.height = "151px");
    },
    async getServiceList() {
      const { data } = await customerServiceInfo();
      data.forEach((item) => {
        item.isLoading = false;
      });
      this.serviceList = data;
    },
    async hanldeRenewal(i) {
      console.log("ccc", i);
      i.isLoading = true;
      switch (i.serviceType) {
        case "基础版":
          try {
            let BaseRes = await this.$http.get(
              `salary-service/customer/package/${i.serviceType}/name`
            );
            this.$store.commit("activeStep", {
              package: true,
              packageDetail: BaseRes.data[0],
            });
            this.$router.push({
              path: "/index/buy",
              query: {
                type: "renewal",
                endtime: i.endtime,
                starttime: i.beginTime,
                infoid: i.id,
              },
            });
          } catch {
            i.isLoading = false;
          }
          break;
        case "高级版":
          try {
            let advancedRes = await this.$http.get(
              `salary-service/customer/package/${i.serviceType}/name`
            );
            this.$store.commit("activeStep", {
              package: true,
              packageDetail: advancedRes.data[0],
            });

            this.$router.push({
              path: "/index/buy",
              query: {
                type: "renewal",
                endtime: i.endtime,
                starttime: i.beginTime,
                infoid: i.id,
              },
            });
          } catch {
            i.isLoading = false;
          }
          break;
        case "VIP版":
          //  let res = await this.$http.get("package_service/all");

          try {
            let vipList = await this.$http.get(
              `salary-service/customer/package/${i.serviceType}/name`
            );
            console.log(vipList.data, "vipList.data");
            this.$store.commit("handleVip", {
              list: vipList.data,
              detail: vipList.data[0],
            });
            this.$router.push({
              path: "/index/buy",
              query: {
                type: "renewal",
                endtime: i.endtime,
                starttime: i.beginTime,
                infoid: i.id,
              },
            });
          } catch {
            i.isLoading = false;
          }
          break;
      }
    },
  },
  mounted() {
    this.getServiceList();
  },
};
</script>

<style lang="less" scoped>
.buy-btn {
  cursor: pointer;
  margin-top: 15px;
  border: 1px solid rgba(59, 196, 146, 1);
  border-radius: 14px;
  color: #000;
  &:hover {
    background: rgba(59, 196, 146, 1);
    color: #fff !important;
  }
}
.border-class {
  border-top-width: 3px;
  border-top-style: solid;
  p {
    line-height: 2;
  }
}
.index {
  padding: 42px 0;
  .title-contact {
    font-size: 16px;
    float: right;
    line-height: 30px;
  }
  .buy-content {
    display: flex;
    flex-wrap: wrap;
    transition: height 0.5s;
    overflow: hidden;
    > div {
      margin: 15px 1% 0 1%;
      width: 31%;
      border-left: 1px solid rgba(224, 234, 241, 1);
      border-right: 1px solid rgba(224, 234, 241, 1);
      border-bottom: 1px solid rgba(224, 234, 241, 1);
      padding: 20px 32px;
      h4 {
        font-size: 18px;
        margin-bottom: 20px;
      }
      p {
        font-size: 14px;
        font-weight: 400;
        color: rgba(131, 143, 153, 1);
        span {
          float: right;
          color: #000;
        }
      }
    }
  }
  .btn-container {
    text-align: center;
    margin-top: 15px;
    span {
      cursor: pointer;
    }
  }
}
</style>
